import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.justify ? props.justify : 'center')};
  align-items: ${props => (props.align ? props.align : 'center')};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify }) => (justify ? justify : 'center')};
  align-items: ${({ align }) => (align ? align : 'center')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'none')};
`;
